import { Alert, AlertDescription } from "@/components/ui/alert";

import { FEED_ISSUES_COPY, issueKey, issueLine, type FeedIssue } from "./feed_issues";

/**
 * The highlighted note on figures read from a feed with an open issue (C1 v1.60, GATE-1089): wherever the figures are shown, one
 * line per issue saying the feed is stale, its last good date and why. Nothing when C2 names none (or predates `feed_issues`).
 * `compact` is the projection's form, inside the box it qualifies.
 */
export function FeedIssuesNote({ issues, compact = false }: { issues: FeedIssue[]; compact?: boolean }) {
  if (issues.length === 0) return null;
  if (compact) {
    return (
      <div role="note" className="mt-1 rounded-sm border border-ks-warn p-1 text-xs text-ks-ink" data-feed-issues="compact">
        <p className="font-semibold">{FEED_ISSUES_COPY.short}</p>
        <ul>{issues.map((i) => <li key={issueKey(i)}>{issueLine(i)}</li>)}</ul>
      </div>
    );
  }
  return (
    <Alert role="note" className="border-ks-warn" data-feed-issues="">
      <AlertDescription>
        <p className="font-semibold text-ks-ink">{FEED_ISSUES_COPY.heading}</p>
        <ul className="flex flex-col gap-1">{issues.map((i) => <li key={issueKey(i)}>{issueLine(i)}</li>)}</ul>
      </AlertDescription>
    </Alert>
  );
}
